import React from "react";

export default function InfoIcon({ className = "", fill = "#FF6A00" }) {
  return (
    <React.Fragment>
      <svg
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M33 54C44.598 54 54 44.598 54 33C54 21.402 44.598 12 33 12C21.402 12 12 21.402 12 33C12 44.598 21.402 54 33 54Z"
          fill={fill}
        />
        <circle
          cx="30"
          cy="30"
          r="22"
          fill="white"
          stroke="#222222"
          strokeWidth="2"
        />
        <path d="M30.8214 19L30.8213 34" stroke="#222222" strokeWidth="2" />
        <path d="M31 41L31 38" stroke="#222222" strokeWidth="3" />
      </svg>
    </React.Fragment>
  );
}
